<script>

import AmsuScholarshipCard from "../AmsuScholarshipCard.vue";
import TheMeetingScholarshipParameterForm from "../../Form/TheMeetingScholarshipParameterForm.vue";
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";
import CreateProtocolScholarship from "../../Services/CreateProtocolScholarship";
import TheMeetingParameterInformationDialog
  from "../../Dialogs/Meeting/Information/TheMeetingParameterInformationDialog.vue";
import TheMeetingSectionParamsMeeting from "./TheMeetingSectionParamsMeeting.vue";
export default {
  name: "TheMeetingScholarshipParameterCard",

  components: {
    TheMeetingSectionParamsMeeting,
    AmsuScholarshipCard,
    TheMeetingScholarshipParameterForm,
    TheMeetingParameterInformationDialog,
  },

  props: {
    loading: {
      type: Boolean,
      default: false,
    }
  },

  data() {
    return {
      showInformationDialog: false,
    };
  },

  computed: {

    ...mapState({
      meeting: state => state.scholarship_meeting.meeting,
      statements: state => state.scholarship_competition.statements,
    }),

    ...mapGetters({
      completeStatements: 'scholarship_meeting/completeStatements',
    }),

    departmentName() {
      return this.meeting?.department?.name
    },

    meetingStudyYear() {
      return this.meeting?.study_year
    },

    meetingSemester() {
      return this.meeting?.semester
    },
  },

  methods: {
    ...mapMutations({
      setPayloadMeeting: "scholarship_meeting/setPayloadMeeting",
    }),

    clickUpdateMeeting() {
      this.setPayloadMeeting();
      this.$emit('openEditMeeting');
    },


    protocolScholarship() {
      const protocol = CreateProtocolScholarship;

      protocol.department = this.departmentName;
      protocol.employees = this.people;
      protocol.statements = this.statements;
      protocol.meeting = this.meeting;

      protocol.cratePDF();
    },

    extractScholarshipDocument() {
      const protocol = CreateProtocolScholarship;

      protocol.department = this.departmentName;
      protocol.employees = this.people;
      protocol.statements = this.completeStatements;
      protocol.meeting = this.meeting;

      protocol.cratePDFExtract();
    },
  }
}
</script>

<template>
  <amsu-scholarship-card
    :loading="loading"
  >
    <v-card-title>
      Параметры заседания
      <v-spacer/>
      <v-btn
        icon
        @click="showInformationDialog = true"
      >
        <v-icon>fa-question-circle</v-icon>
      </v-btn>
    </v-card-title>
    <v-divider/>

    <v-card-text>
      <v-row>
        <v-col cols="8">
          <v-list-item>
            <v-list-item-content>
              <v-list-item-title>
                {{departmentName}}
              </v-list-item-title>
              <v-list-item-subtitle>
                Семестер {{meetingSemester}}
              </v-list-item-subtitle>
              <v-list-item-subtitle>
                Учебный год {{meetingStudyYear}}
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-col>
        <v-col cols="4">

        </v-col>
      </v-row>
    </v-card-text>

    <v-divider/>

    <v-card-text class="d-flex">
      <v-btn
        small
        color="teal darken-3"
        class="rounded-xl"
        outlined
        @click="protocolScholarship"
        :disabled="!meeting.access_current_meeting"
      >
        Протокол
      </v-btn>

      <div class="mx-2"></div>

      <v-btn
        class="rounded-xl"
        small
        color="teal darken-3"
        outlined
        @click="extractScholarshipDocument"
        :disabled="!meeting.access_current_meeting"
      >
        Выписка
      </v-btn>
    </v-card-text>

    <v-divider/>

    <the-meeting-section-params-meeting :meeting="meeting"/>

    <v-divider/>

    <v-card-actions>
      <v-spacer/>
      <v-btn
        color="teal darken-3"
        class="rounded-xl white--text"
        @click="clickUpdateMeeting"
        :disabled="!meeting.access_current_meeting"
      >
        Редактировать
      </v-btn>
    </v-card-actions>

    <the-meeting-parameter-information-dialog
      :visible="showInformationDialog"
      @close="showInformationDialog = false"
    />
  </amsu-scholarship-card>
</template>

<style scoped>

</style>